import { useContext, useEffect, useState } from "react";
// DATEPICKER
import "dayjs/locale/es";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
// DATEPICKER
import {
  Grid,
  TextField,
  Button,
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Typography,
  Autocomplete,
  Divider,
  Alert,
  styled,
  Fade,
  IconButton,
} from "@mui/material";
import {
  Clear,
  Check,
  NoteAdd,
  ArrowForwardIos,
  Update,
  Send,
  Add,
  CloudUpload,
  Close,
  UploadFile,
} from "@mui/icons-material";

import { CustomIcons, handleDates } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import ChipsInput from "../../../Components/Common/Design/ChipsInput";
import {
  DocsContext,
  PermissionContext,
} from "../../../Components/Context/Context";
import api from "../../../api/axios";

/**
 * RevisionContent
 * - Recibe props y valida su existencia con valores por defecto.
 * - Incluye try/catch en peticiones asíncronas.
 * - Mantiene todos los bloques comentados que tenías.
 * - Maneja render errors devolviendo un fallback simple.
 */
const RevisionContent = ({
  sectionId = false,
  mailTemplatesData = [],
  nextTask = () => {},
  caseId = null,
  dataCase = {},
  setUpdatedCase = () => {},
  updatedCase = false,
  activeTask = {},
  userLogged = {},
}) => {
  const Swal = require("sweetalert2");

  // Extraemos contexto con fallback seguro
  const docsContext = useContext(DocsContext) || {};
  const {
    docsChangedFlag = false,
    setDocsChangedFlag = () => {},
    setDocsLoading = () => {},
    docsInfo = [],
  } = docsContext;

  const { can } = useContext(PermissionContext);
  const canEdit = can("cases", "edit");
  const canManageDocs = can("cases", "docs");
  // DATAPICKER
  const [dateFromDefault, setDateFromDefault] = useState(dayjs());
  // DATAPICKER

  const [selectedMailTemplate, setSelectedMailTemplate] = useState(null);

  const [revisionLimitDateInputFormat, setRevisionLimitDateInputFormat] =
    useState(dayjs());
  const [changeRevisionState, setChangeRevisionState] = useState({});
  const [updateLimitTaskDate, setUpdateLimitTaskDate] = useState(false);

  const [chipsValues, setChipsValues] = useState([]);

  const [currentChipsValues, setCurrentChipsValues] = useState(
    activeTask?.config?.morefiles || [],
  );

  const [uploadedFiles, setUploadedFiles] = useState({});

  const getRevisionContentStatus = activeTask?.status == 0;

  const getTaskOrderById = (taskId) => {
    const flow = (dataCase?.completeFlow || []).find(
      (item) => Number(item?.id) === Number(taskId),
    );
    return Number(flow?.order || 0);
  };

  const activeTaskOrder = getTaskOrderById(activeTask?.task_id);
  const hasLaterPendingTask = (dataCase?.tasks || []).some(
    (task) =>
      Number(task?.status) === 0 &&
      getTaskOrderById(task?.task_id) > activeTaskOrder,
  );

  const shouldShowCompletePendingTaskButton =
    getRevisionContentStatus && hasLaterPendingTask;

  const changeRevisionStateData = [
    {
      name: "Rechazar Caso",
      value: 2,
      icon: <Clear />,
      color: "error",
      flag: !shouldShowCompletePendingTaskButton,
    },
    {
      name: "Aceptar Caso",
      value: 1,
      icon: <Check />,
      color: "success",
      flag: !shouldShowCompletePendingTaskButton,
    },
    {
      name: "Solicitar más documentación",
      value: 0,
      icon: <NoteAdd />,
      color: "warning",
      flag: shouldShowCompletePendingTaskButton || getRevisionContentStatus,
    },
  ];

  const resetRevisionState = () => {
    setUploadedFiles({});
    setChipsValues([]);
    setCurrentChipsValues([]);
    setSelectedMailTemplate(null);
  };

  const handleRevisionData = () => {
    // Configuración de la siguiente fase (archivos requeridos)
    var config = {};

    if (changeRevisionState?.value === undefined) {
      Swal.fire({
        title: "Atención",
        text: "Debe seleccionar una opción para continuar.",
        icon: "info",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Entendido",
      });
      return;
    }

    if (changeRevisionState?.value === 0 && chipsValues.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Debe agregar los nombres de los documentos que desea solicitar",
        icon: "error",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Volver",
      });
      return;
    }

    {
      try {
        Swal.fire({
          title: "¿Actualizar el caso?",
          icon: "warning",
          showDenyButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Sí",
          denyButtonText: "Volver",
          cancelButtonColor: "#d33",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            if (changeRevisionState?.value == 2) {
              Promise.resolve(
                nextTask(
                  activeTask?.config ? activeTask?.config : config,
                  2,
                  true,
                  "",
                ), // Llama a la función para avanzar en el proceso
              ).finally(() => {
                resetRevisionState();
              });
            } else if (changeRevisionState?.value == 1) {
              // Configuracion, avanza por lo que ownState es false, proximo estado del task actual, flag de control para el backend ( indicador de siguiente tarea )
              Promise.resolve(
                nextTask(config, 1, "next", activeTask?.message), // Llama a la función para avanzar en el proceso
              ).finally(() => {
                resetRevisionState();
              });
            } else if (changeRevisionState?.value == 0) {
              if (chipsValues?.length > 0) {
                config = {
                  morefiles: Array.isArray(activeTask?.config?.morefiles)
                    ? [...activeTask?.config?.morefiles, ...chipsValues]
                    : chipsValues, // chipsValues debe ser un array ["documentacion", "X", "Y", "Z"]
                };

                const safeChips =
                  Array.isArray(chipsValues) && chipsValues.length > 0
                    ? chipsValues
                    : [];

                const newMessage = `<div class="feed-element"><div><span class="label label-info pull-right">${dayjs().format(
                  "DD/MM/YYYY HH:mm",
                )}</span><hr><strong>NOTA:</strong> Se necesita más documentación: <b>${
                  safeChips.length ? safeChips.join(", ") : "No especificada"
                }</b> <hr></div></div>`;

                let fullMessage = "";

                if (activeTask?.message) {
                  fullMessage = newMessage + activeTask?.message;
                } else {
                  fullMessage = newMessage;
                }

                Promise.resolve(
                  nextTask(config, 0, true, fullMessage), // Llama a la función para avanzar en el proceso
                ).finally(() => {
                  resetRevisionState();
                });
              } else {
                Swal.fire({
                  title: "Error",
                  text: "Debe agregar los nombres de los documentos que desea solicitar",
                  icon: "error",
                  showDenyButton: false,
                  confirmButtonColor: "#1ab394",
                  confirmButtonText: "Volver",
                  cancelButtonColor: "#d33",
                  reverseButtons: true,
                });
              }
            }
          }
        });
      } catch (err) {
        console.error("Error en handleRevisionData:", err);
        // Fallback: mostrar alerta simple
        Swal.fire({
          title: "Error interno",
          text: "Ocurrió un error al procesar la acción. Reintenta o contacta soporte.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    }
  };

  /**
   * handleUpdateLimitDate
   * - Añadido try/catch alrededor de la llamada API.
   * - Validaciones de fecha y de dataCase.
   */
  const handleUpdateLimitDate = () => {
    try {
      const date = handleDates(revisionLimitDateInputFormat);

      if (date) {
        Swal.fire({
          title: "¡Cuidado!",
          html: "<div>Estás a punto de cambiar la fecha de </div><div>¿Desea continuar?</div>",
          icon: "warning",
          confirmButtonColor: "#1ab394",
          cancelButtonColor: "#d33",
          reverseButtons: true,
          denyButtonText: "Volver",
          confirmButtonText: "Continuar",
          showDenyButton: true,
        }).then(async (response) => {
          if (response.isConfirmed) {
            try {
              const formData = new FormData();
              formData.append("case_id", Number(caseId || 0));
              formData.append("date_end", date);
              formData.append("id", Number(dataCase?.task?.id || 0));

              const url = `${process.env.REACT_APP_API_URL}/cases/updatetaskdate`;

              try {
                const response = await api.post(url, formData);

                if (response) {
                  Swal.fire({
                    title: "Guardado",
                    icon: "success",
                    confirmButtonText: "Finalizar",
                    confirmButtonColor: "#1ab394",
                  });

                  setUpdatedCase(!updatedCase);
                }
              } catch (error) {
                console.error("Error en api.post(update task date):", error);
                Swal.fire({
                  title: "Error",
                  text: "No se pudo actualizar la fecha. Intenta de nuevo.",
                  icon: "error",
                  confirmButtonColor: "#d33",
                });
              }
            } catch (errInner) {
              console.error(
                "Error preparando formulario en handleUpdateLimitDate:",
                errInner,
              );
            }
          }
        });
      }
    } catch (err) {
      console.error("Error en handleUpdateLimitDate (outer):", err);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un problema al intentar cambiar la fecha.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  /**
   * handleChipsChange
   */
  const handleChipsChange = (chips) => {
    try {
      setChipsValues(chips || []);
    } catch (err) {
      console.error("Error en handleChipsChange:", err);
    }
  };

  /**
   * handleCleanRequiredDoc
   * - Mantengo toast: true y el resto de la logica.
   */
  const handleCleanRequiredDoc = (dato) => {
    try {
      Swal.fire({
        title: "¡Cuidado!",
        text: `¿Desea eliminar la solicitud del documento: ${dato}?`,
        icon: "warning",
        confirmButtonText: "Continuar",
        denyButtonText: "Volver",
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        showDenyButton: true,
        toast: true,
        //  position: "top-end",
      }).then(async (response) => {
        if (response.isConfirmed) {
          try {
            const newMoreFiles = (currentChipsValues || []).filter(
              (item) => item !== dato,
            );

            const config = {
              morefiles: Array.isArray(newMoreFiles) ? newMoreFiles : [], // chipsValues debe ser un array ["documentacion", "X", "Y", "Z"]
            };

            const formDataTask = new FormData();
            formDataTask.append("current_task", activeTask?.id || "");
            formDataTask.append("config", JSON.stringify(config));

            const url = `${process.env.REACT_APP_API_URL}/casestasks/updatetasks`;

            try {
              const response = await api.post(url, formDataTask);

              if (response) {
                Swal.fire({
                  title: "Guardado",
                  icon: "success",
                  confirmButtonText: "Finalizar",
                  confirmButtonColor: "#1ab394",
                });

                setUpdatedCase(!updatedCase);
              }
            } catch (error) {
              console.error("Error en api.post(updatetasks):", error);
              Swal.fire({
                title: "Error",
                text: "No se pudo actualizar la tarea. Intenta de nuevo.",
                icon: "error",
                confirmButtonColor: "#d33",
              });
            }
          } catch (errInner) {
            console.error("Error interno en handleCleanRequiredDoc:", errInner);
          }
        }
      });
    } catch (err) {
      console.error("Error en handleCleanRequiredDoc (outer):", err);
    }

    // Actualizamos el estado eliminando el valor que coincide con 'dato'
  };

  /**
   * handleFileChange
   */
  const handleFileChange = (event, fileName) => {
    try {
      const filesArray = Array.from(event?.target?.files || []);
      setUploadedFiles((prev) => ({
        ...prev,
        [fileName]: filesArray, // se guarda cada archivo bajo su "file" requerido
      }));
    } catch (err) {
      console.error("Error en handleFileChange:", err);
    }
  };

  /**
   * handleUploadAwaitingDocs
   * - Manejo completo con try/catch
   */
  const handleUploadAwaitingDocs = async () => {
    try {
      //   Confirmación inicial
      Swal.fire({
        title: "¿Deseas continuar?",
        text: "Se subirán los archivos y se actualizará la tarea.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then(async (result) => {
        if (!result.isConfirmed) return; //  Si cancela, no hace nada

        try {
          const today = dayjs().format("DD/MM/YYYY");

          const formData = new FormData();
          formData.append("case_id", Number(caseId || 0));
          formData.append("user_id", userLogged?.id || 0);
          formData.append("folder", "Sin Carpeta");
          formData.append("flag_name", true);

          Object.entries(uploadedFiles || {}).forEach(([key, files]) => {
            (files || []).forEach((file) => {
              const ext = (file?.name || "").split(".").pop();
              const newName = `${key}.${ext}`;
              const renamedFile = new File([file], newName, {
                type: file?.type || "",
              });

              formData.append(`files[]`, renamedFile);
              formData.append(`doc_desc`, `Recibido/Enviado el ${today}`);
            });
          });

          // Se crea un nuevo array eliminando aquellos elementos que ya han sido subidos
          const uploadedKeys = Object.keys(uploadedFiles || {});
          const newConfigAfterUpload = (
            activeTask?.config?.morefiles || []
          ).filter((item) => !uploadedKeys.includes(item));

          const urlUpload = `${process.env.REACT_APP_API_URL}/s3/store`;

          // Loader inicial
          Swal.fire({
            title: "Subiendo archivos...",
            text: "Por favor espera mientras procesamos los documentos.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          try {
            const response = await api.post(urlUpload, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });

            if (!response?.data) {
              throw new Error("Error en la subida de archivos");
            }
          } catch (error) {
            console.error("Error subiendo archivos a s3/store:", error);
            Swal.fire({
              title: "Error",
              text: "Ocurrió un problema durante la subida. Intenta de nuevo.",
              icon: "error",
              confirmButtonColor: "#d33",
            });
            return;
          }

          // Configuración para la segunda petición
          const config = {
            morefiles: Array.isArray(newConfigAfterUpload)
              ? newConfigAfterUpload
              : [],
          };

          const formDataTask = new FormData();
          formDataTask.append("current_task", activeTask?.id || "");
          formDataTask.append("config", JSON.stringify(config));

          const urlUpdate = `${process.env.REACT_APP_API_URL}/casestasks/updatetasks`;

          try {
            const responseTask = await api.post(urlUpdate, formDataTask);

            //  Éxito total
            Swal.fire({
              title: "Éxito",
              text: "Los archivos fueron subidos y la tarea se actualizó correctamente.",
              icon: "success",
              confirmButtonText: "Finalizar",
              confirmButtonColor: "#1ab394",
            });

            setUpdatedCase(!updatedCase);
            setDocsLoading(true);
            setDocsChangedFlag((prev) => !prev);

            //  RESET TOTAL UI
            setUploadedFiles({});
            setChipsValues([]);
            setCurrentChipsValues([]);
            setSelectedMailTemplate(null);
          } catch (error) {
            console.error("Error actualizando tarea tras subida:", error);
            Swal.fire({
              title: "Error",
              text: "Ocurrió un problema al actualizar la tarea tras la subida.",
              icon: "error",
              confirmButtonColor: "#d33",
            });
          }
        } catch (errInner) {
          console.error(
            "Error interno en la promesa de confirmación:",
            errInner,
          );
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error inesperado.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      });
    } catch (err) {
      console.error("Error en handleUploadAwaitingDocs:", err);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un problema tratando de subir los archivos.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleCompletePendingTask = () => {
    if (!activeTask?.id || !caseId) return;

    Swal.fire({
      title: "¿Dar por completada esta tarea?",
      text: "Solo se marcará la tarea actual como completada.",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      confirmButtonText: "Sí",
      reverseButtons: true,
      denyButtonText: "Volver",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        await api.post(
          `${process.env.REACT_APP_API_URL}/casestasks/complete-pending-task`,
          {
            id: Number(activeTask.id),
            case_id: Number(caseId),
          },
        );

        Swal.fire({
          title: "Guardado",
          text: "La tarea actual se completó correctamente.",
          icon: "success",
          confirmButtonColor: "#1ab394",
        });

        setUpdatedCase(!updatedCase);
      } catch (error) {
        console.error("Error al completar tarea pendiente:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudo completar la tarea actual.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    });
  };

  // Preparar datos seguros para render
  const safeDocs = Array.isArray(docsInfo)
    ? docsInfo
    : docsInfo && typeof docsInfo === "object"
      ? Object.values(docsInfo)
      : [];

  const morefiles = activeTask?.config?.morefiles || [];

  // Intentamos renderizar; si hay error, devolvemos fallback con información mínima
  try {
    return (
      <Grid container item xs={12}>
        {activeTask?.message && (
          <Grid
            container
            item
            xs={12}
            sx={{
              boxShadow: "0px 0px 5px 0px rgb(197 224 235)",
              padding: "10px",
              mb: "10px",
            }}>
            <Grid item xs={12}>
              <h4 style={{ margin: "10px auto" }}>SOLICITUDES</h4>

              <div
                dangerouslySetInnerHTML={{ __html: activeTask?.message || "" }}
              />
            </Grid>

            {(() => {
              // Aseguramos que safeDocs sea siempre un array
              const safeArray = Array.isArray(safeDocs) ? safeDocs : [];

              // Extraemos paths existentes
              const existingPaths = safeArray.map((doc) => doc?.path || "");

              // Aseguramos que morefiles sea un array
              const safeMoreFiles = Array.isArray(morefiles)
                ? morefiles.filter(
                    (f) => typeof f === "string" && f.trim().length > 0,
                  )
                : [];

              // Aseguramos que uploadedFiles sea un objeto
              const safeUploadedFiles =
                uploadedFiles && typeof uploadedFiles === "object"
                  ? uploadedFiles
                  : {};

              return (
                <Grid item xs={12} mb={"10px"}>
                  {safeMoreFiles.map((file, i) => {
                    const filesForThisDoc =
                      typeof file === "string" &&
                      Array.isArray(safeUploadedFiles[file])
                        ? safeUploadedFiles[file]
                        : [];

                    return (
                      <div key={i}>
                        {can("cases", "docs") && (
                          <Alert
                            severity="warning"
                            sx={{
                              "& .MuiAlert-message": {
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              },
                              marginBottom: "5px",
                            }}>
                            <div>
                              <span>Título del documento requerido: </span>
                              <b>{file || "Sin nombre"}</b>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}>
                              {/* Mostrar solo los archivos de este input */}
                              {filesForThisDoc.length > 0 && (
                                <>
                                  {filesForThisDoc.map((f, index) => {
                                    if (!f) return null; // protección
                                    return (
                                      <div
                                        key={index}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}>
                                        📄 {f.name || "Archivo sin nombre"} (
                                        {Math.round(
                                          ((f.size || 0) / 1024) * 100,
                                        ) / 100}{" "}
                                        KB)
                                        {(f.type || "").startsWith(
                                          "image/",
                                        ) && (
                                          <img
                                            src={URL.createObjectURL(f)}
                                            alt={f.name || "imagen"}
                                            style={{ width: "100px" }}
                                          />
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              )}

                              <Button
                                component="label"
                                role={undefined}
                                variant="outlined"
                                tabIndex={-1}
                                startIcon={<CloudUpload />}
                                color="warning"
                                size="small"
                                sx={{ mr: "10px" }}>
                                <span style={{ paddingTop: "2px" }}>
                                  Cargar
                                </span>
                                <input
                                  type="file"
                                  hidden
                                  multiple
                                  onChange={(event) =>
                                    typeof handleFileChange === "function"
                                      ? handleFileChange(event, file)
                                      : null
                                  }
                                />
                              </Button>

                              <IconButton
                                color="error"
                                sx={{
                                  border: "1px solid",
                                  borderColor: "error.main",
                                  borderRadius: "10px",
                                }}
                                aria-label="close"
                                onClick={() =>
                                  typeof handleCleanRequiredDoc === "function"
                                    ? handleCleanRequiredDoc(file)
                                    : null
                                }>
                                <Close />
                              </IconButton>
                            </div>
                          </Alert>
                        )}
                      </div>
                    );
                  })}

                  {safeMoreFiles.length > 0 && (
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "end",
                      }}>
                      <CustomButtonPlusIcon
                        color={"warning"}
                        icon={UploadFile}
                        handleFunction={
                          typeof handleUploadAwaitingDocs === "function"
                            ? handleUploadAwaitingDocs
                            : () => {}
                        }
                        text={"Subir Documentación solicitada"}
                        position={"start"}
                        variant={"contained"}
                      />
                    </div>
                  )}
                </Grid>
              );
            })()}
          </Grid>
        )}

        {can("cases", "edit") && getRevisionContentStatus && (
          <Grid container item xs={12}>
            <Grid
              container
              item
              xs={12}
              sx={{
                border: "1px dashed #f4f9ff",
                backgroundColor: "#f4f9ff",
                mb: "10px",
              }}>
              <Grid
                item
                xs={6}
                className="alignItemsAndLeft"
                sx={{ padding: "15px 10px" }}>
                <b>ACTUALIZAR FECHA DE FIN DE TAREA:</b>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  padding: "15px 10px",
                  justifyContent: "end",
                  width: "100%",
                  alignItems: "stretch",
                  gap: 1,
                  display: "flex",
                }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="es">
                  <DesktopDatePicker
                    renderInput={(props) => (
                      <TextField {...props} size="small" fullWidth />
                    )}
                    label="Fecha de fin de tarea"
                    value={dayjs(dataCase?.task?.date_end) || dayjs()}
                    size="small"
                    onChange={(newValue) => {
                      setRevisionLimitDateInputFormat(newValue);
                    }}
                  />
                </LocalizationProvider>

                <CustomButtonPlusIcon
                  // icon={Autorenew}
                  icon={Update}
                  handleFunction={handleUpdateLimitDate}
                  variant={"outlined"}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid container item xs={6} gap={"10px"}>
                <Grid item xs={12} sx={{ padding: "10px" }}>
                  <b>ACTUALIZAR:</b>{" "}
                  <span>
                    Una vez revisada toda la documentación actualice el caso.
                  </span>
                </Grid>
                <Grid item xs={12} sx={{ padding: "10px" }}>
                  <FormControl component="fieldset" width={"100%"}>
                    <FormLabel component="legend" sx={{ fontSize: "14px" }}>
                      Seleccione una opción:
                    </FormLabel>
                    {changeRevisionStateData.map((option) => {
                      if (option?.value == 0 && !canManageDocs) {
                        return null;
                      }

                      if (option?.flag !== true) {
                        return null;
                      }

                      return (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              checked={changeRevisionState.name === option.name}
                              onChange={() => {
                                setChangeRevisionState(option);
                              }}
                              value={option.value}
                              name={option.name}
                              color={option.color}
                            />
                          }
                          label={
                            <Typography
                              style={{
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                              }}
                              color={option.color}
                              variant="contained">
                              {option.icon} {option.name}
                            </Typography>
                          }
                        />
                      );
                    })}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sx={{ gap: "10px", display: "block" }}>
                <Fade
                  in={
                    changeRevisionState?.name == "Solicitar más documentación"
                  }
                  timeout={300}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      border: "1px dashed #f4f9ff",
                      backgroundColor: "#f4f9ff",
                      padding: "10px",
                      display: "flex-column",
                      gap: "10px",
                      height: "100%",
                    }}>
                    <Typography
                      color="main"
                      variant="body2"
                      sx={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "700",
                      }}>
                      Introduce cada nombre de documento y presiona ENTER o
                      pulsa en el botón <Add />
                    </Typography>
                    <ChipsInput
                      // initialChips={["Carlos", "Ana"]}
                      label="Documentos a solicitar"
                      onChange={handleChipsChange}
                      maxChips={15}
                      chipsValues={chipsValues}
                    />
                  </Grid>
                </Fade>
                {/* <Grid item xs={12} sx={{ padding: "10px" }}>
            <Autocomplete
              sx={{ width: "100%" }}
              size="small"
              value={selectedMailTemplate}
              onChange={(event, value) => {
                // Verifica si value es un valor válido antes de asignarlo
                if (value) {
                  setSelectedMailTemplate(value);
                }
              }}
              disabled
              options={mailTemplatesData} // Asegúrate de que `options` esté definido correctamente
              getOptionLabel={(option) =>
                "Pendiente " + option.mail_title || ""
              } // Fallback si 'label' es undefined
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ fontSize: "14px" }}
                  label="Plantilla de Notificación"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ padding: "10px" }}>
            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                htmlFor="maittoclientbody"
                style={{ fontSize: "14px" }}
              >
                Mensaje
              </FormLabel>
              <textarea
                name="maittoclientbody"
                id="maittoclientbody"
                rows="10"
                disabled
                style={{
                  width: "99%",
                  fontSize: "14px",
                  border: "1px solid rgba(128, 128, 128, 0.35)",
                }}
              ></textarea>
            </FormControl>
          </Grid> */}
              </Grid>
              <Grid item xs={12} py={"10px"}>
                <Divider width={"100%"} />
              </Grid>
              <Grid container item xs={12} sx={{ textAlign: "end" }}>
                <Grid item xs={6}></Grid>
                <Grid item xs={6} sx={{ textAlign: "end" }}>
                  {shouldShowCompletePendingTaskButton && canEdit ? (
                    <CustomButtonPlusIcon
                      icon={ArrowForwardIos}
                      text={"Dar por completada la tarea"}
                      handleFunction={handleCompletePendingTask}
                      position={"end"}
                      variant={"contained"}
                      color={"success"}
                      fullWidth={true}
                      size={"small"}
                    />
                  ) : (
                    <Button
                      size="small"
                      color="success"
                      variant="contained"
                      onClick={handleRevisionData}
                      endIcon={
                        <CustomIcons
                          icon={Send}
                          width={"18px"}
                          height={"18px"}
                        />
                      }>
                      <span className="reOrderTextButton">
                        Actualizar y enviar
                      </span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  } catch (renderError) {
    console.error("Render error en RevisionContent:", renderError);
    return (
      <Grid container item xs={12} sx={{ p: 2 }}>
        <Alert severity="error">
          Ocurrió un error al renderizar este componente. Revisa consola para
          más detalles.
        </Alert>
      </Grid>
    );
  }
};

export default RevisionContent;
